export const volumes = [
  {
    number: '01',
    title: 'Prevención y hábitos saludables',
    body: 'Charlas sobre alimentación, actividad física, hidratación, higiene, salud bucal, sueño, prevención del tabaquismo, salud cardiovascular y controles periódicos.',
    flow: ['Prevenir', 'Educar', 'Promover hábitos'],
  },
  {
    number: '02',
    title: 'Salud materno-infantil y pediatría',
    body: 'Recursos sobre lactancia, alimentación complementaria, crecimiento, desarrollo, vacunación, prevención de accidentes, salud bucal infantil y otros temas frecuentes.',
    flow: ['Informar', 'Acompañar', 'Prevenir'],
  },
  {
    number: '03',
    title: 'Enfermedades crónicas y autocuidado',
    body: 'Charlas sobre hipertensión, diabetes, salud cardiovascular, controles, uso seguro de medicamentos, alimentación y autocuidado.',
    flow: ['Comprender', 'Cuidar', 'Acompañar'],
  },
  {
    number: '04',
    title: 'Salud comunitaria y prevención',
    body: 'Dengue, infecciones respiratorias, vacunación, salud sexual, prevención de ITS, accidentes domésticos, salud ambiental y otros temas comunitarios.',
    flow: ['Educar', 'Prevenir', 'Actuar en comunidad'],
  },
  {
    number: '05',
    title: 'Cómo dar charlas de salud efectivas',
    body: 'Aprendé a organizar el contenido, adaptar el lenguaje, captar la atención, hacer participar al público, manejar el tiempo y cerrar con mensajes claros.',
    flow: ['Planificar', 'Comunicar', 'Hacer participar'],
  },
];
